import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { setRatio } from 'shared/actions/globals';
import { getDisplayName } from '../helpers/common';

const setRatioImage = (image, ratio, width, height, fit = 'cover') => {
  if (!image) {
    return image;
  }

  const aS3Regexp = /^(https:\/\/a[\d].s3.ua)/;
  const cndRegexp = /^(https:\/\/cdn.+(ab|s3).ua)/;
  const awsWithoutIRHRegexp = /^((https:\/\/d2wkv3iadoqiil.cloudfront.net\/)(\w*\/)?(\w*\/)?(.{32})(\..*)?)/;
  const awsWithIRHRegexp = /^((https:\/\/d1672trkrgk4ug.cloudfront.net\/)(.*))/;
  const dimensions = [width, height].map(x => (x ? Math.round(x * ratio) : '')).join('x');
  const httpsImage = image.replace('http:', 'https:');

  if (width || height) {
    if (httpsImage.match(cndRegexp)) {
      return httpsImage.replace('/image/', `/unsafe/${dimensions}/`);
    }

    if (httpsImage.match(aS3Regexp)) {
      return httpsImage.replace(aS3Regexp, `$1/${dimensions}`);
    }

    if (httpsImage.match(awsWithoutIRHRegexp)) {
      const groups = httpsImage.match(awsWithoutIRHRegexp);
      let size = 'large';
      if (width) {
        if (width * ratio <= 600) {
          size = 'small';
        } else if (width * ratio <= 900) {
          size = 'medium';
        }
      }

      const root = groups[3] && groups[3] === 'original/' ? '' : groups[3];
      return `${groups[2] + (root || '')}${size}/${groups[5] + (groups[6] || '')}`;
    }

    if (httpsImage.match(awsWithIRHRegexp)) {
      const groups = httpsImage.match(awsWithIRHRegexp);
      const imageRequest = JSON.stringify({
        key: `${groups[3]}`,
        edits: {
          resize: {
            width: width ? Math.round(width * ratio) : null,
            height: height ? Math.round(height * ratio) : null,
            fit,
          },
        },
      });

      return `${groups[2]}${Buffer.from(imageRequest).toString('base64')}`;
    }
  }

  return httpsImage;
};

/*
const mapStateToProps = ({ globals }) => ({ ratio: globals.ratio });
const mapDispatchToProps = { setRatio };
*/
const mapStateToProps = () => ({});
const mapDispatchToProps = {};

// TODO: Commented code can be removed after testing, and be sure this code do not have some side effects.

const withPixelRatio = WrappedComponent =>
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    class extends React.Component {
      static displayName = `withPixelRatio(${getDisplayName(WrappedComponent)})`;

      /*
      static propTypes = {
        // setRatio: PropTypes.func.isRequired,
        ratio: PropTypes.number,
      };
      static defaultProps = {
        ratio: null,
      }; */

      /*
      componentDidMount() {
        if (!this.props.ratio) {
          this.props.setRatio();
        }
      }
      */

      /*
      setRatioImage = (image, width = 240, height = null) =>
        setRatioImage(image, this.props.ratio, width, height);
      */
      setRatioImage = (image, width = 240, height = null, fit = 'cover') =>
        setRatioImage(image, 1, width, height, fit);

      setRatioAlbum = (images, width, height) =>
        images.map(({ image, ...rest }) => ({
          ...rest,
          image: this.setRatioImage(image, width, height),
        }));

      render() {
        // const { ratio, ...props } = this.props;
        const ratio = 1;
        const { ...props } = this.props;

        return (
          <WrappedComponent
            setRatioAlbum={this.setRatioAlbum}
            setRatioImage={this.setRatioImage}
            ratio={ratio}
            {...props}
          />
        );
      }
    },
  );

export default withPixelRatio;



// WEBPACK FOOTER //
// ./src/shared/hocs/withPixelRatio.js